import { render, staticRenderFns } from "./AccountMyTradeJournalsJournal.vue?vue&type=template&id=c6161daa&scoped=true&"
import script from "./AccountMyTradeJournalsJournal.vue?vue&type=script&lang=js&"
export * from "./AccountMyTradeJournalsJournal.vue?vue&type=script&lang=js&"
import style0 from "./AccountMyTradeJournalsJournal.vue?vue&type=style&index=0&id=c6161daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6161daa",
  null
  
)

export default component.exports